export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6802.0091d39c.jpg";